import { useQuery } from '@tanstack/react-query';
import { useRecoilValue } from 'recoil';

import { axiosInstance } from '../../../axios/axiosInstance';
import { userData } from '../../../recoil/atoms/userDataAtom';
import { ChatMeta } from '../../model/interfaces/ChatMeta';

export const chatMetaKey = ['CHAT_META'];

interface ChatMetaResponse {
  data: ChatMeta;
}

export const useGetChatMeta = () => {
  const user = useRecoilValue(userData);

  return useQuery<ChatMetaResponse>({
    queryKey: [...chatMetaKey],
    queryFn: async () => {
      const { data } = await axiosInstance.get('/api/users/me/messages');
      return data;
    },
    enabled: !!user?.data?.id,
    retry: 2,
    retryDelay: 1000
  });
};
